module.exports = __webpack_public_path__ + "media/images/pc/banner/winter_campaign-dc86749641a09d592c7ed0b22a1b400c.png";